import { createFileRoute } from '@tanstack/react-router'
import GtmPurchasePage from '@/pages/gtm-purchase'

export const Route = createFileRoute('/$lang/gtm/purchase/$checkoutId')({
  component: GtmPurchasePage,
  staticData: { layout: 'public' },
})
